<template>
  <div :class="b()">
    <div :class="b('inner')">
      <c-course-tile
        v-if="slideType === 'course'"
        :course="data"
      />
      <c-blog-list-item
        v-else-if="slideType === 'blog'"
        :entry="data"
      />
      <c-cms-tile
        v-else-if="slideType === 'page'"
        :content="data"
      />
    </div>
  </div>
</template>

<script>
  import cBlogListItem from '@/components/c-blog-list-item.vue';
  import cCmsTile from '@/components/c-cms-tile.vue';
  import cCourseTile from '@/components/c-course-tile.vue';

  /**
   * Renders a cms tile slide.
   */
  export default {
    name: 'c-slider-item-4',

    components: {
      cCourseTile,
      cCmsTile,
      cBlogListItem,
    },
    // mixins: [],

    props: {
      /**
       * Expects a course, blog or page data object. See child components for details.
       */
      data: {
        type: Object,
        required: true,
      },

      /**
       * Allows to overwrite the data driven type for the slide.
       */
      type: {
        type: String,
        default: null,
      },
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Returns the component type for the current slide.
       *
       * @returns {String}
       */
      slideType() {
        return this.type || this.data.type;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use 'sass:map';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  c-slider-item-4 {
    width: math.div(364, 1920) * 100vw;
    overflow: hidden;

    &::before {
      display: block;
      content: '';
      float: left;
      width: 0;
      height: 0;
      padding-top: math.percentage(math.div(555, 364));
    }
  }

  .c-slider-item-4 {
    $this: &;
    $border-width: 1px;

    display: flex;
    flex: 0 0 functions.rem(variables.$grid-width--xs);
    justify-content: stretch;
    box-sizing: content-box;
    width: functions.rem(variables.$grid-width--xs);

    @include mixins.media(sm) {
      flex: 0 0 (math.div(328, functions.strip-unit(map.get(variables.$breakpoints, sm))) * 100vw);
      width: (math.div(328, functions.strip-unit(map.get(variables.$breakpoints, sm))) * 100vw);
    }

    @include mixins.media(md) {
      flex: 0 0 (math.div(364, functions.strip-unit(map.get(variables.$breakpoints, xl))) * 100vw);
      width: (math.div(364, functions.strip-unit(map.get(variables.$breakpoints, xl))) * 100vw);
    }

    @include mixins.media(lg) {
      flex: 0 0 (math.div(495, functions.strip-unit(map.get(variables.$breakpoints, lg))) * 100%);
      width: (math.div(495, functions.strip-unit(map.get(variables.$breakpoints, lg))) * 100%);
    }

    &:not(:last-child) {
      padding: functions.rem(0 variables.$grid-padding--xs);

      @include mixins.media(sm) {
        padding: functions.rem(0 variables.$grid-gutter--md 0 0);
      }

      @include mixins.media(md) {
        padding-right: functions.rem(variables.$grid-gutter--lg);
      }
    }

    &__inner {
      position: relative;
      display: flex;
      width: 100%;

      &::before {
        // Animated gradient border. @see https://codepen.io/johnnyfekete/pen/WMoWvb
        @include mixins.z-index(front);

        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: '';
        opacity: 0;

        // IE11
        border: $border-width solid transparent;
        transition:
          background-size variables.$transition-duration--500 linear,
          opacity variables.$transition-duration--1000;
        pointer-events: none;

        @supports (clip-path: none) {
          border: 0;
          background: radial-gradient(
              circle at bottom left,
              variables.$color-gradient--1-0 math.div(variables.$color-gradient--1-start, 2),
              variables.$color-gradient--1-1 math.div(variables.$color-gradient--1-end, 2),
              rgba(variables.$color-gradient--1-1, 0)
            )
            no-repeat left bottom;
          background-size: 200% 200%;

          // stylelint-disable declaration-colon-newline-after
          clip-path: polygon(
            0% 100%,
            $border-width 100%,
            $border-width $border-width,
            calc(100% - #{$border-width}) $border-width,
            calc(100% - #{$border-width}) calc(100% - #{$border-width}),
            $border-width calc(100% - #{$border-width}),
            $border-width 100%,
            100% 100%,
            100% 0%,
            0% 0%
          );
          // stylelint-enable declaration-colon-newline-after

          @include mixins.media(md) {
            opacity: 1;
            background-size: 0 0;
          }
        }
      }

      #{$this}.is-active &::before {
        @include mixins.media($down: md) {
          opacity: 1;
        }
      }

      #{$this}:hover &::before,
      #{$this}:focus &::before,
      .uses-touch #{$this}.is-active &::before {
        opacity: 1;

        // IE11
        border-color: variables.$color-gradient--1-fallback;
        border-image-source: linear-gradient(45deg, variables.$color-gradient--1);
        border-image-slice: 1;

        @include mixins.media(md) {
          background-size: 200% 200%;
        }
      }

      > * {
        width: 100%; // IE11 overflow bugfix.
      }
    }
  }
</style>
